import { requiredFormFields } from '../../const/app';
import { formStepRoutes } from '../../routes/routes';
import { store } from '../../store/store';

export const getLatestValidStepIndex = (): number => {
  const formData = store.getSnapshot().context.form;

  for (let i = 0; i < formStepRoutes.length; i++) {
    const stepKey = formStepRoutes[i].stepKey;
    const stepFormData = formData?.[stepKey] as Record<string, unknown> | undefined;
    const requiredFields = requiredFormFields[stepKey];

    if (!stepFormData || !requiredFields.every((field) => stepFormData[field])) {
      return i;
    }
  }

  return formStepRoutes.length - 1;
};
